module.exports = __webpack_public_path__ + "img/rotate-right.b6cf532f.svg";